function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496.933 496.933",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a46f3e"
    },
    d: "M435.2 238.933c-25.446 0-47.607-13.952-59.349-34.603a86 86 0 0 1-8.917.469c-47.13 0-85.333-38.204-85.333-85.333 0-13.312 3.14-25.865 8.576-37.094C270.276 75.349 256 56.431 256 34.133c0-12.681 4.634-24.26 12.262-33.195C261.402.367 254.481 0 247.467 0 110.797 0 0 110.797 0 247.467s110.797 247.467 247.467 247.467 247.467-110.797 247.467-247.467c0-13.193-1.058-26.129-3.046-38.767-12.255 18.235-33.068 30.233-56.688 30.233",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#a46f3e",
      strokeWidth: 2
    },
    d: "M435.2 238.933c-25.446 0-47.607-13.952-59.349-34.603a86 86 0 0 1-8.917.469c-47.13 0-85.333-38.204-85.333-85.333 0-13.312 3.14-25.865 8.576-37.094C270.276 75.349 256 56.431 256 34.133c0-12.681 4.634-24.26 12.262-33.195C261.402.367 254.481 0 247.467 0 110.797 0 0 110.797 0 247.467s110.797 247.467 247.467 247.467 247.467-110.797 247.467-247.467c0-13.193-1.058-26.129-3.046-38.767-12.255 18.235-33.068 30.233-56.688 30.233z",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a3311"
    },
    d: "M179.2 179.2c0-23.561-19.106-42.667-42.667-42.667S93.867 155.639 93.867 179.2s19.106 42.667 42.667 42.667S179.2 202.761 179.2 179.2",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6a3311",
      strokeWidth: 2
    },
    d: "M179.2 179.2c0-23.561-19.106-42.667-42.667-42.667S93.867 155.639 93.867 179.2s19.106 42.667 42.667 42.667S179.2 202.761 179.2 179.2z",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a3311"
    },
    d: "M179.2 358.4c0-18.85-15.283-34.133-34.133-34.133s-34.133 15.283-34.133 34.133 15.283 34.133 34.133 34.133S179.2 377.25 179.2 358.4",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6a3311",
      strokeWidth: 2
    },
    d: "M179.2 358.4c0-18.85-15.283-34.133-34.133-34.133s-34.133 15.283-34.133 34.133 15.283 34.133 34.133 34.133S179.2 377.25 179.2 358.4z",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a3311"
    },
    d: "M375.467 358.4c0-32.99-26.743-59.733-59.733-59.733S256 325.41 256 358.4s26.743 59.733 59.733 59.733 59.734-26.743 59.734-59.733",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6a3311",
      strokeWidth: 2
    },
    d: "M375.467 358.4c0-32.99-26.743-59.733-59.733-59.733S256 325.41 256 358.4s26.743 59.733 59.733 59.733 59.734-26.743 59.734-59.733z",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a3311"
    },
    d: "M283.803 100.388a86 86 0 0 1 6.374-18.014c-19.9-7.023-34.176-25.941-34.176-48.239 0-2.893.307-5.7.768-8.457-.265-.009-.503-.077-.768-.077-23.569 0-42.667 19.098-42.667 42.667 0 23.561 19.098 42.667 42.667 42.667 10.676 0 20.319-4.062 27.802-10.547",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6a3311",
      strokeWidth: 2
    },
    d: "M283.803 100.388a86 86 0 0 1 6.374-18.014c-19.9-7.023-34.176-25.941-34.176-48.239 0-2.893.307-5.7.768-8.457-.265-.009-.503-.077-.768-.077-23.569 0-42.667 19.098-42.667 42.667 0 23.561 19.098 42.667 42.667 42.667 10.676 0 20.319-4.062 27.802-10.547z",
    transform: "translate(1.006 -2.06)scale(1.00617)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#6b6c6e",
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.903 47.314h-.267c-.723.02-1.199-1.085-1.75-1.085h-4.302c-.533 0-.647.8-.628 1.142 0 0-.666.305-.361 1.523-.038.019-.381.342-.381.97s.362.933.362.933-.362.4-.362.99.514.913 1.047.913h1.58c1.37 0 1.255.742 1.255.742s.153 1.922.647 2.817c.61 1.103 1.827.742 1.37-.704-.342-1.066 1.2-2.665 1.77-3.198m.533.723h2.874c.533 0 .552-.4.552-.913v-4.625c0-.494-.02-.913-.552-.913h-2.874c-.533 0-.552.4-.552.913v4.625c0 .495.02.913.552.913z",
    style: {
      fill: "#fff",
      strokeWidth: 0.38062277
    },
    transform: "translate(-1450.295 -397.756)scale(12.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectAll);
export default __webpack_public_path__ + "static/media/reject_all.c23d549732c28c06a294ad1960911689.svg";
export { ForwardRef as ReactComponent };